import { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppRouter } from './router';
import { ToastProvider } from '@/components/ui';
import { TrainingRequestPanelPortal } from '@/components/training-request/TrainingRequestPanelPortal';
import { DocumentA11ySync } from '@/components/accessibility/DocumentA11ySync';
import { LyrraAccessPadIndicator } from '@/components/accessibility/LyrraAccessPadIndicator';
import { GlobalMagnifierProvider } from '@/components/accessibility/GlobalContentMagnifier';
import { LyrraOneBrandSync } from '@/components/brand/LyrraOneBrandSync';
import { CustomDomainSiteProvider } from '@/contexts/CustomDomainSiteContext';
import { useAuthStore } from '@/stores/auth.store';
import { useLanguageStore } from '@/stores/language.store';
import { isLyrraOne } from '@/lib/platform';
import { syncMarketingLanguageCookie } from '@/lib/language-prefs';
import { usePublicRegionStore } from '@/stores/public-region.store';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  const user = useAuthStore((s) => s.user);

  useEffect(() => {
    syncMarketingLanguageCookie();
    if (isLyrraOne()) {
      void usePublicRegionStore.getState().initialize();
    }
    void useLanguageStore.getState().initializeVisitorLocale();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <CustomDomainSiteProvider>
        <LyrraOneBrandSync />
        <DocumentA11ySync />
        <LyrraAccessPadIndicator />
        <ToastProvider>
          {user && <TrainingRequestPanelPortal />}
          <GlobalMagnifierProvider>
            <AppRouter />
          </GlobalMagnifierProvider>
        </ToastProvider>
      </CustomDomainSiteProvider>
    </QueryClientProvider>
  );
}

export default App;
